'use client';

import Link from 'next/link';
import { env } from '@/utils/env';
import type { FooterLegalLink } from './legalLinks';

/** PC/WAP 共用点击语义，布局和埋点由各端传入。 */
export default function FooterLegalItem({
  item,
  className,
  onActivate,
}: {
  item: FooterLegalLink;
  className?: string;
  onActivate?: () => void;
}) {
  if (item.jump === 'popup') {
    return (
      <button
        type="button"
        className={`cursor-pointer ${className ?? ''}`}
        aria-label={item.label}
        aria-haspopup="dialog"
        onClick={() => {
          onActivate?.();
          if (
            env.NEXT_PUBLIC_ENABLE_ONETRUST === 'true' &&
            typeof window.OneTrust?.ToggleInfoDisplay === 'function'
          ) {
            window.OneTrust.ToggleInfoDisplay();
          } else if (
            env.NEXT_PUBLIC_ENABLE_CONSENT_MANAGER === 'true' &&
            typeof window.__cmp === 'function'
          ) {
            // 与非美国站历史 Cookie 链接 ?cmpscreen 保持相同的弹窗入口。
            window.__cmp('showScreen');
          }
        }}
      >
        {item.label}
      </button>
    );
  }

  return (
    <Link
      prefetch={false}
      href={item.href}
      aria-label={item.label}
      className={className}
      onClick={(event) => {
        onActivate?.();
        // 仅兼容未配置 jump 的旧数据；指定链接始终按后台地址导航。
        if (
          item.jump === undefined &&
          item.href === env.NEXT_PUBLIC_COOKIE_TARGET &&
          env.NEXT_PUBLIC_ENABLE_ONETRUST === 'true' &&
          typeof window.OneTrust?.ToggleInfoDisplay === 'function'
        ) {
          event.preventDefault();
          window.OneTrust.ToggleInfoDisplay();
        }
      }}
    >
      {item.label}
    </Link>
  );
}
